import { useMutation } from '@tanstack/react-query';
import { ITranscriptSummarizeRequest, ITranscriptSummaryResponse } from '../../../viewmodels/CalendarViewModels';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export function useAdminTranscriptSummarizeMutation() {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: ITranscriptSummarizeRequest) => {
			return userSession.webServiceHelper.callAsync<ITranscriptSummaryResponse>(
				'admin/zoom/transcripts/summarize',
				'POST',
				request
			);
		},
	});
}
